import { BRAND_USER_BASE_URL, SHOP_USER_BASE_URL } from '../../../constants';

export const SHOPIFY_NOT_SET = 'not-set';
export const SHOPIFY_MATCHES = 'product-matches';

export const SHOPIFY_DOMAIN = 'myshopify.com';
export const SHOPIFY_CONNECTION_FORM = 'shopifyConnectionForm';

export const GET_SHOPIFY_SETTINGS = 'GET_SHOPIFY_SETTINGS';
export const GET_SHOPIFY_SETTINGS_ERROR = 'GET_SHOPIFY_SETTINGS_ERROR';
export const SAVE_SHOPIFY_SETTINGS = 'SAVE_SHOPIFY_SETTINGS';
export const SET_SHOPIFY_STATE = 'SET_SHOPIFY_STATE';

export const GET_SHOPIFY_MATCHES = 'GET_SHOPIFY_MATCHES';
export const SET_SHOPIFY_MATCHES = 'SET_SHOPIFY_MATCHES';
export const RESET_SHOPIFY_MATCHES = 'RESET_SHOPIFY_MATCHES';
export const GET_SHOPIFY_REMOTE_LOCATIONS = 'GET_SHOPIFY_REMOTE_LOCATIONS';
export const SET_SHOPIFY_REMOTE_LOCATIONS = 'SET_SHOPIFY_REMOTE_LOCATIONS';
export const GET_SHOPIFY_REMOTE_LOCATIONS_ERROR = 'GET_SHOPIFY_REMOTE_LOCATIONS_ERROR';
export const SET_SHOPIFY_SELECTED_ITEMS = 'SET_SHOPIFY_SELECTED_ITEMS';
export const SET_SHOPIFY_ALL_SELECTED = 'SET_SHOPIFY_ALL_SELECTED';
export const RESET_SHOPIFY_SELECTED_ITEMS = 'RESET_SHOPIFY_SELECTED_ITEMS';
export const PRODUCTS_SHOPIFY_PATH = '/products/shopify';

export const BRAND_USER_PRODUCTS_SHOPIFY_PATH = `${BRAND_USER_BASE_URL}${PRODUCTS_SHOPIFY_PATH}`;
export const SHOP_USER_PRODUCTS_SHOPIFY_PATH = `${SHOP_USER_BASE_URL}${PRODUCTS_SHOPIFY_PATH}`;

export const PRODUCT_SKU = 'sku';
export const PRODUCT_SQUIRE_NAME = 'squireName';
export const PRODUCT_SHOPIFY_NAME = 'shopifyName';

export const INITIAL_MATCHES_STATUS_COMPLETED = 'completed';

// "type"?: enum(pd, inv) - Type of items (product details or inventory, product details by default)
export const PRODUCT_DETAILS = 'pd';
export const PRODUCT_INVENTORY = 'inv';
export const DEFAULT_MATCHES_LIMIT = 1000;
export const DEFAULT_MATCHES_PAGE = 0;
